import { Injectable } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";

/**
 * Serviço responsável por lidar com ícones SVG.
 */
@Injectable({
    providedIn: "root"
})
export class SvgHandlerService {

    constructor(private readonly domSanitizer: DomSanitizer) {
    }

    convertToBase64(customSvg: string, color = "#666") {
        const svg = this.getSvgWithCustomColor(customSvg, color)
        return this.getSVGImageUrl(svg);
    }

    getSvgWithCustomColor(customSvg: string, color = "#666") {
        return customSvg.replace(new RegExp(/{color}/g), color);
    }

    getSVGImageUrl(image) {
        const base64string = btoa(image);
        return this.domSanitizer.bypassSecurityTrustResourceUrl(`data:image/svg+xml;base64,${base64string}`); //NOSONAR
    }
}
